// src/services/CountryService.js
import api from "./api";

export function getSubject(page = 1, limit = 10, search = "") {
    return api.get(`/subject?page=${page}&limit=${limit}&search=${search}`);
}

export function getSubjectById(id) {
    return api.get(`/subject/${id}`);
}

export function addSubject(data) {
    return api.post("/subject", data);
}

export function updateSubject(id, data) {
    return api.put(`/subject/${id}`, data);
}

export function deleteSubject(id) {
    return api.delete(`/subject/${id}`);
}
